<template>
  <action-dispatcher action="sale/get" :parameters="{}">
    <div class="view-sales-coproducer-index">
      <h1 class="page-title">
        Relatório de coprodução
        <small>
          Visualize a receita gerada no período selecionado.
        </small>
      </h1>
      <div
        v-if="!sales.length"
        class="container centralize-row text-center pt-9"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block mb-9 mx-auto"
              src="@/assets/images/home/welcome.png"
            />
            <h5>Você ainda não realizou vendas!</h5>
            <div class="text-secondary mb-9">
              Após configurar seu produto, comece enviando o link de divulgação
              para seus clientes
            </div>

            <router-link class="btn btn-primary" :to="{ name: 'product' }">
              Visualizar Produtos
            </router-link>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row mb-6">
          <div class="col-lg-8">
            <div class="d-flex align-items-center ">
              <h6 class="mr-6 d-lg-none">
                Comissões recebidas
              </h6>
              <h5 class="mr-6 d-none d-lg-block">
                Comissões recebidas
              </h5>
              <button
                class="btn btn-sm btn-outline-primary btn-square-sm p-5"
                @click="refresh"
              >
                <i class="icon-refresh-ccw" />
              </button>
            </div>
          </div>
        </div>
        <sale-bar-chart
          chartColor="#9155EC"
          :externalLoading="loading"
          @change-product="onChangeProduct"
          @change-currency="onChangeCurrency"
          @change-dates="onChangeDates"
        />
        <div class="row py-6">
          <div class="col-lg-4 py-3">
            <total :refresh="loading" />
          </div>
          <div class="col-lg-4 py-3">
            <card>
              <h6 class="mb-5">Quantidade de vendas</h6>
              <h5 class="text-dark">{{ pagination.count }}</h5>
            </card>
          </div>
        </div>
        <div v-if="loading" class="text-center">
          <b-spinner variant="primary" />
        </div>
        <div v-else>
          <!-- mobile area start -->
          <data-table
            class="d-lg-none"
            :columns="['', '']"
            :data="salesLoremIpsum"
            :showSeparator="false"
            :firstColumnFr="2"
            :lastColumnFr="0.2"
          >
            <template #default="{ item }">
              <div class="p-5 d-flex flex-column">
                <small class="mb-2">
                  <strong>Período: </strong>{{ item.created_at | formatDate }}
                </small>
                <small class="mb-2">
                  <strong>Produto: </strong
                  >{{ item.product_name | formatLongText }}
                </small>
                <small class="mb-2">
                  <strong>Quantidade de Vendas:</strong> {{ item.sales_count }}
                </small>
                <small class="mb-2">
                  <strong>Receita: </strong>R$ {{ item.sales_count }}
                </small>
              </div>
              <div></div>
            </template>
          </data-table>
          <!-- mobile area  end-->
          <!-- desktop area  start-->
          <data-table
            class="d-none d-lg-block"
            :columns="responsive.columns"
            :data="salesLoremIpsum"
            :showSeparator="false"
            :firstColumnFr="1"
            :lastColumnFr="0.5"
          >
            <template #default="{ item }">
              <small class="d-flex align-items-center pl-3">
                {{ item.created_at | formatDate }}
              </small>
              <small class="pr-2 d-flex align-items-center">{{
                item.product_name
              }}</small>
              <small class="pr-2 d-flex align-items-center"
                >{{ item.sales_count }}
              </small>
              <small class="d-flex align-items-center"
                >R$ {{ item.amount }}
              </small>
            </template>
          </data-table>
          <!-- desktop area end-->
        </div>
        <div class="d-flex justify-content-center">
          <paginator :pagination="pagination" @on-update="onPaginationUpdate" />
        </div>
        <responsive-modal v-if="focusedSale" size="lg" v-model="modal.details">
          <sale-detail :sale_id="focusedSale.id" />
        </responsive-modal>
      </div>
    </div>
  </action-dispatcher>
</template>
<script>
import SaleBarChart from "@/components/reports/SaleBarChart.vue";
import SaleDetail from "@/components/sale/Details.vue";
import Total from "@/components/sale/TotalCard.vue";
import SaleMixin from "@/mixins/sale";
import { mapState } from "vuex";

export default {
  mixins: [SaleMixin],
  components: { SaleDetail, Total, SaleBarChart },
  data() {
    return {
      loading: false,
      focusedSale: null,
      modal: {
        details: false
      },
      filters: {
        product_id: null
      },
      responsive: {
        columns: ["Período", "Produto", "Quantidade de Vendas", "Receita"],
        actions: [
          {
            text: "Detalhes",
            class: "",
            icon: "icon-exclamation-outline",
            confirmation: {
              enable: false,
              text: ""
            },
            event: "open-details"
          }
        ]
      },
      salesLoremIpsum: [
        {
          created_at: "2021-03-24T17:06:28.000000Z",
          product_name: "Troca Justa - 17",
          sales_count: 540,
          amount: "213.356,12"
        },
        {
          created_at: "2021-03-24T17:06:28.000000Z",
          product_name: "Troca Justa - 17",
          sales_count: 40,
          amount: "213.356,12"
        },
        {
          created_at: "2021-03-24T17:06:28.000000Z",
          product_name: "Troca Justa - 17",
          sales_count: 1540,
          amount: "213.356,12"
        },
        {
          created_at: "2021-03-24T17:06:28.000000Z",
          product_name: "Troca Justa - 17",
          sales_count: 340,
          amount: "213.356,12"
        }
      ]
    };
  },
  watch: {
    "modal.details"(val) {
      if (!val) {
        this.focusedSale = null;
      }
    },
    "filters.product_id"(product_id) {
      let param = {};
      if (product_id !== "all") {
        param = { product_id };
      }
      this.loading = true;
      this.$store
        .dispatch("sale/get", param)
        .then()
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    ...mapState("sale", ["sales", "pagination"]),
    ...mapState("product", ["product", "products"])
  },
  methods: {
    refresh() {
      this.loading = true;
      this.$store
        .dispatch("sale/get", {})
        .then()
        .finally(() => {
          this.loading = false;
        });
    },
    search(search) {
      this.loading = true;
      this.$store
        .dispatch("sale/get", { search })
        .then()
        .finally(() => {
          this.loading = false;
        });
    },
    onPaginationUpdate(offset) {
      let filters = {};
      if (this.filters.product_id) {
        filters = this.filters;
      }
      this.$store
        .dispatch("sale/get", { offset, ...filters })
        .then()
        .finally(() => {
          this.loading = false;
        });
    },
    openDetail(item) {
      this.focusedSale = item;
      this.modal.details = true;
    },
    exportData() {},
    onChangeProduct(product_id) {
      let param = {};
      if (product_id !== "all") {
        param = { product_id };
      }
      this.loading = true;
      this.$store
        .dispatch("sale/get", param)
        .then()
        .finally(() => {
          this.loading = false;
        });
    },
    onChangeCurrency(currency_id) {},
    onChangeDates(dates_range) {
      // this.$store
      //   .dispatch("sale/get", {
      //     start_date: dates_range[0],
      //     end_date: dates_range[0]
      //   })
      //   .then()
      //   .catch(err => {
      //     this.$message.error("Não foi possível pegar as vendas nesse periodo");
      //   });
    }
  }
};
</script>
<style lang="scss" scoped>
.view-sales-coproducer-index {
  .btn-outline-warning {
    min-height: 20px;
  }
}
</style>
